import { render, staticRenderFns } from "./ProductPreviewLowView.vue?vue&type=template&id=9f77cfd4&scoped=true"
import script from "./ProductPreviewLowView.vue?vue&type=script&lang=js"
export * from "./ProductPreviewLowView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f77cfd4",
  null
  
)

export default component.exports